import React, { useEffect } from 'react'
import { MotifEy } from '@ey-xd/motif-icon'
import {
  MotifButton,
  MotifHeader,
  MotifHeaderLogo,
  MotifIcon,
} from '@ey-xd/motif-react'
import { useMsal } from '@azure/msal-react';
import User from '@/features/User/User';
import styles from './index.module.scss'
import { useNavigate } from 'react-router-dom';

export const Header: React.FC = () => {
  const { instance, accounts } = useMsal()
  const navigate = useNavigate();
  const isAuthenticated = accounts.length > 0
  const activeAccount = instance.getActiveAccount()

  useEffect(() => {
    // Set active account if not already set but accounts exist
    if (accounts.length > 0 && !activeAccount) {
      instance.setActiveAccount(accounts[0])
    }
  }, [instance, accounts, activeAccount])

  return (        
    <div className="motif-no-padding">
      <MotifHeader 
        className={styles.header}
        fixed={true}
        appHeaderName="SOD"
        logo={
            <MotifHeaderLogo>
            <a aria-label="EY FAIT SOD" href="/" onClick={(e) => { 
              e.preventDefault(); 
              navigate('/');
            }}>
              <MotifIcon iconFunction={MotifEy} aria-hidden="true" size='40' />
            </a>
            </MotifHeaderLogo>
        }  
        rightComponents={
          <>
            {isAuthenticated ? (
              <User />
            ) : (
              <MotifButton size="medium" aria-label="Click to open help" type="button" variant='secondary' onClick={() => window.open('https://live.atlas.ey.com', '_blank')}>
                Help
              </MotifButton>
            )}
          </>
        }
      />
    </div>
  )
}
